
import React from "react";
import { Switch } from "@/components/ui/switch";
import { Poll } from "@/types/poll";
import { Info } from "lucide-react";

interface PollAnonymousVotingFieldProps {
  currentPoll: Poll;
  updateField: (field: keyof Poll, value: any) => void;
}

const PollAnonymousVotingField = ({
  currentPoll,
  updateField,
}: PollAnonymousVotingFieldProps) => {
  return (
    <div className="space-y-2">
      <div className="font-medium">Voting Access</div>
      
      <div className="flex items-center justify-between rounded-md border p-4">
        <div className="space-y-0.5">
          <div className="font-medium">Allow Anonymous Voting</div>
          <div className="text-sm text-muted-foreground flex items-start gap-1">
            <Info className="h-4 w-4 text-blue-500 mt-0.5 flex-shrink-0" />
            <span>When enabled, users can vote without verification or login</span>
          </div>
        </div>
        <Switch
          checked={currentPoll.anonymous_allowed || false}
          onCheckedChange={(checked) => updateField("anonymous_allowed", checked)}
        />
      </div>
    </div>
  );
};

export default PollAnonymousVotingField;
